<template>
  <div class="header-container">
    <component :is="headerComponent" />
    <div class="header-user-wrapper">
      <div @click="showDropDown = !showDropDown" class="user">
        <span class="d-none d-md-block" :class="showDropDown ? 'active' : ''">{{ name }}</span>
        <div class="user-avatar">
          <img v-if="user.logo_file_uuid" class="popup_image" :src="path" alt />
          <span v-else>{{ fullNameShort }}</span>
        </div>
      </div>
      <div @click="showDropDown = !showDropDown">
      <header-drop-down
        v-click-outside="outside"
        v-if="showDropDown"
        :balance="balance"
        :user_type="user_type"
        @click="showDropDown = false"
      />
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    PrimarySelect: () => import("./Inputs/PrimarySelect.vue"),
    HeaderDropDown: () => import("./HeaderDropDown.vue"),
    DahboardComponent: () => import("./Header/DahboardComponent.vue"),
    AlertComponent: () => import("./Header/AlertComponent.vue"),
  },
  data: () => ({
    showDropDown: false,
    headerComponent: "AlertComponent",
    company: [],
    name: null,
    balance: null,
    user_type: null,
  }),
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    path() {
      const path_logo = this.user && this.user.logo_file_uuid;

      if (!path_logo) {
        return;
      }
      return `http://88.198.219.62/api_smsc/v1/file/${path_logo}`;
    },
    fullNameShort() {
      if(this.user.first_name && this.user.last_name) {
        const first_letter_of_firstname = this.user.first_name[0];
        const last_letter_of_lastname = this.user.last_name[0];
        return `${first_letter_of_firstname}${last_letter_of_lastname}`;
      }
    },
  },
  async created() {
    this.getBalance();
    if (this.$store.state.user.user) {
      this.user_type = this.$store.state.user.user.user_type;
      if (this.user_type === "admin") {
        this.name =
          this.$store.state.user.user.first_name +
          " " +
          this.$store.state.user.user.last_name;
      } else if (this.user_type === "reseller") {
        this.name = `${this.$store.state.user.user.first_name} ${this.$store.state.user.user.last_name}`;
        console.log(this.name);
      } else if (this.user_type === "user") {
        this.name =
          this.$store.state.user.user.first_name +
          " " +
          this.$store.state.user.user.last_name;
      } else if (this.user_type === "company_admin") {
        this.name =
          this.$store.state.user.user.first_name +
          " " +
          this.$store.state.user.user.last_name;
      }
    }
    this.company = this.$store.state.company.company;
  },
  methods: {
    outside() {
      this.showDropDown = false;
    },
    getBalance() {
      this.$store.dispatch("GetBalance", this.user.company_uuid).then((res) => {
        if (res.data.payload && res.data.payload.total) {
          this.balance = res.data.payload.items[0].balance;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container {
  position: sticky;
  top: 0;
  z-index: 99;
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .header-user-wrapper {
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: flex-end;

    .popup_image {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 0;
    }
    .user {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      z-index: 900;
      // margin-right: 30px;
      margin: 15px 15px 15px 0;
      span {
        /*margin-right: 10px;*/
        font-family: "Helvetica Neue";
        font-size: 15px;
        line-height: 20px;
        text-align: right;
        color: #55616e;
      }
      .active {
        color: #51a3f3;
      }
      .user-avatar {
        margin-left: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #eceef0;
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 15px;
        text-align: center;
        //margin-right: 15px;
      }
    }
  }
}
</style>

